# Step Actions
# =================
SupportHelpWizardController = require('../helpWizardController')
Backbone = require 'backbone'
Backbone.$ = $

class SupportStepActionsView extends Backbone.View
  className: 'row step-actions'

  initialize: (options) ->
    @options = options || {}
    @template = @options.template
    @I18nScope = 'modules.support'
    @model = Groupon.Support.stepActionModel

  events:
    'click #continue-with-order': 'continueWithOrder'
    'click #not-order-related': 'notOrderRelated'
    'click .back': 'goToPreviousStep'
    'click #problem-solved': 'renderProblemSolved'
    'click #contact-us': 'contactUs'
    'click #request-refund': 'continueToTicket'
    'click #continueToTicket': 'continueToTicket'
    "click #orderNotListed" : "orderNotListed"
    "click #chooseOrder"  : "chooseDifferentOrder"
    'click #otherContactChannel': 'chooseDifferentContactChannel'

  render: ->
    @$el.append toHtml(@template, @model.toHash(), @I18nScope)
    @delegateEvents()

  continueWithOrder: ->
    $("#continue-with-order").hide()
    Groupon.Support.NOT_ORDER_RELATED = false
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate("#select-issue", {trigger: true}))

  contactUs: ->
    data = getTrackingHubData()
    TrackingHub.add("still-need-help", {stillNeedHelp: data})
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate('#contact-us', {trigger: true}))

  continueToTicket: ->
    data = getTrackingHubData()
    TrackingHub.add("continue-to-ticket", {continueToTicket: data})
    propagateEventBeforeReplacingElements( ->
      @$('.refund-my-request').hide()
      Backbone.history.navigate('#contact-us', {trigger: true})
    )

  renderProblemSolved: ->
    data = getTrackingHubData()
    TrackingHub.add("problem-solved", {problemSolved: data})
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate('#problem-solved', {trigger: true}))

  notOrderRelated: ->
    Groupon.Support.NOT_ORDER_RELATED = true
    data =
      permalink: if window.currentUser? then window.currentUser.id else "anonymous"
    TrackingHub.add("order-not-related", {orderNotRelated: data})
    propagateEventBeforeReplacingElements(->
      SupportHelpWizardController.changeCurrentOrder(null)
      Backbone.history.navigate("#select-issue", {trigger: true})
    )

  orderNotListed: () ->
    Groupon.Support.ORDER_NOT_LISTED = true
    Groupon.Support.NOT_ORDER_RELATED = false
    SupportHelpWizardController.changeCurrentOrder(null)
    Backbone.history.navigate('#select-issue', {trigger: true})
    return false

  chooseDifferentContactChannel: () ->
    SupportHelpWizardController.stepThree()

  chooseDifferentOrder: () ->
    SupportHelpWizardController.changeCurrentOrder(null)
    SupportHelpWizardController.initOrdersFetch()

  goToPreviousStep: ->
    if Groupon.Support.MAXINDEX == 3 then index = Groupon.Support.CURRENTVIEW.id
    else index = Groupon.Support.CURRENTVIEW.id + 1
    switch index
      when 3 then propagateEventBeforeReplacingElements( ()->
        Backbone.history.navigate('#select-issue', {trigger: true})
      )

      when 2 then propagateEventBeforeReplacingElements( ->
        window.selectOrderFromMygroupons = false
        Backbone.history.navigate('#pick-order', {trigger: true})
      )

getTrackingHubData = ()->
  category: Groupon.Support.ContentModel.getCategory()?.id
  subCategory: Groupon.Support.ContentModel.getSubCategory()?.id
  permalink: if window.currentUser? then window.currentUser.id else "anonymous"

module.exports = SupportStepActionsView
